var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer-container"},[_c('div',{staticClass:"Footer-Box"},[_c('span',{staticClass:"CopyRight-Sign"},[_vm._v(_vm._s(_vm.copysign)),_c('span',{staticClass:"CopyRight-Text"},[_vm._v(_vm._s(_vm.getCopyRights))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6b8fb18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 